
import Link, { LinkProps } from '@mui/material/Link'
import { Link as RouterLink } from 'react-router-dom'
import React from 'react'

interface LinkRouterProps extends LinkProps {
  to: string
  replace?: boolean
}

// Forward ref to the RouterLink so it can be used in MUI `component` prop
export const LinkRouter = React.forwardRef<HTMLAnchorElement, LinkRouterProps>(
  function LinkRouter(props, ref) {
    // MUI Link will pass its props; ensure ref is forwarded to the router link
    return <Link {...props} component={RouterLink as any} ref={ref} />
  }
)

LinkRouter.displayName = 'LinkRouter'